import { HasCustomFields } from '@/shared/types/customFields';
import { GridColumnSettings } from '@/shared/types/grid';

export const customFieldColumns = <T extends HasCustomFields>(): GridColumnSettings<T>[] => {
  return [
    {
      headerText: 'Custom 1',
      uid: 'customField1',
      field: 'customField1',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 2',
      uid: 'customField2',
      field: 'customField2',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 3',
      uid: 'customField3',
      field: 'customField3',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 4',
      uid: 'customField4',
      field: 'customField4',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 5',
      uid: 'customField5',
      field: 'customField5',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 6',
      uid: 'customField6',
      field: 'customField6',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 7',
      uid: 'customField7',
      field: 'customField7',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 8',
      uid: 'customField8',
      field: 'customField8',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 9',
      uid: 'customField9',
      field: 'customField9',
      type: 'string',
      visible: false,
    },
    {
      headerText: 'Custom 10',
      uid: 'customField10',
      field: 'customField10',
      type: 'string',
      visible: false,
    },
  ];
};
